// extracted by mini-css-extract-plugin
export var closeButton = "_r-5";
export var container = "_r-0";
export var contentContainer = "_r-1";
export var desktop = "_r-2";
export var fullModalImage = "_r-6";
export var mobile = "_r-3";
export var withImage = "_r-4";